import { useRef } from 'react'
import Box from '@mui/material/Box'
import PieChart from '../control/amChart/PieChart'
import Grid from '@mui/material/Grid'

const AmChart = () => {
    return (
        <Box sx={{ p: 2 }}>
            <Grid container>
                <Grid item xs={12}>
                    <PieChart
                        chartName="pieChartdiv"
                        chartData={chartData}
                        dataFieldsValue="litres"
                        dataFieldsCategory="country"
                        sxProps={{
                            m: 1,
                            // width: 800,
                            height: 800
                        }}
                        legend={{
                            position: "bottom"
                        }}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

const chartData = [{
    "country": "Lithuania",
    "litres": 501.9
}, {
    "country": "Czech Republic",
    "litres": 301.9
}, {
    "country": "Ireland",
    "litres": 201.1
}, {
    "country": "Germany",
    "litres": 165.8
}, {
    "country": "Australia",
    "litres": 139.9
}, {
    "country": "Austria",
    "litres": 128.3
}, {
    "country": "UK",
    "litres": 99
}, {
    "country": "Belgium",
    "litres": 60
}, {
    "country": "The Netherlands",
    "litres": 50
}]

export default AmChart
